<div class="h-full max-h-[99vh]">
  <div
    cdkTrapFocus
    class="overflow-y-auto hide-scrollbar md:show-scrollbar relative w-[434px] max-w-full max-h-[600px] h-full px-8 pb-4 pt-14 rounded flex flex-col gap-4"
    [style.backgroundColor]="bgBase()"
  >
    <p class="text-center font-medium text-lg leading-none">
      {{ 'Zaloguj się lub załóż konto' | translate }}
    </p>

    <p class="text-sm leading-none text-center">
      {{
        'Zaloguj się, aby dokończyć zakup, pobrać bilety i sprawdzić historię zamówień. Nie masz jeszcze konta? Załóż je szybko i wygodnie.'
          | translate
      }}
    </p>

    <form
      [formGroup]="loginFormVM"
      (ngSubmit)="onLogin()"
      class="flex flex-col gap-4"
      role="form"
    >
      <fieldset class="flex flex-col gap-4">
        <legend class="sr-only">
          {{ 'Dane do logowania' | translate }}
        </legend>

        <neopos-input-text
          inputId="input-email"
          formControlName="email"
          [label]="'Adres e-mail *' | translate"
          [placeholder]="'Wprowadź swój adres e-mail' | translate"
          labelMode="E-COMMERCE"
          padding="medium"
          [autoFocus]="true"
          [errorColor]="accent()"
          autocomplete="email"
        />

        <div class="flex flex-col gap-1">
          <neopos-input-text
            inputId="input-password"
            formControlName="password"
            [label]="'Aktualne hasło *' | translate"
            [placeholder]="'Wprowadź swoje hasło' | translate"
            type="password"
            labelMode="E-COMMERCE"
            padding="medium"
            [errorColor]="accent()"
          />

          <button
            type="button"
            (click)="onOpenRestorePasswordModal()"
            class="text-xs leading-none font-medium ml-auto"
            [style.color]="primary()"
          >
            {{ 'Nie pamiętasz hasła?' | translate }}
          </button>
        </div>
      </fieldset>

      <acc-button
        type="submit"
        [inputId]="'acc-button-login-submit'"
        [attr.ariaLabel]="'Zaloguj się' | translate"
      >
        {{ 'Zaloguj się' | translate }}
      </acc-button>

      @if (hasFacebook() || hasGoogle()){
      <span class="mx-auto text-sm leading-none">{{ 'lub' | translate }}</span
      >} @if (hasGoogle()){
      <acc-button
        type="button"
        [inputId]="'acc-button-login-google'"
        theme="SOCIAL"
        iconName="google"
        [iconSize]="24"
        (onClick)="onGoogleLogin()"
        [attr.ariaLabel]="'Zaloguj się z Google' | translate"
      >
        {{ 'Zaloguj się z Google' | translate }} </acc-button
      >} @if (hasFacebook()){
      <acc-button
        type="button"
        [inputId]="'acc-button-login-facebook'"
        theme="SOCIAL"
        iconName="facebook"
        [iconSize]="24"
        (onClick)="onFacebookLogin()"
        [attr.ariaLabel]="'Zaloguj się z Facebook' | translate"
      >
        {{ 'Zaloguj się z Facebook' | translate }} </acc-button
      >}
    </form>

    <p class="text-center text-sm leading-none">
      {{ 'Nie masz konta?' | translate }}

      <button
        (mousedown)="$event.preventDefault()"
        (click)="onOpenRegisterModal()"
        class="text-sm leading-none"
        [style.color]="primary()"
      >
        {{ 'Załóż konto' | translate }}
      </button>
    </p>

    <neopos-icon-button
      name="close"
      (click)="$event.preventDefault(); close()"
      (document:keydown.escape)="close()"
      className="text-[24px]"
      class="absolute top-4 right-4"
    />
  </div>
</div>
